import { IPerson } from '../../../../../../../../../../../store/features/person/interface/IPerson'

export const findPersonUuid = (personList: IPerson[], personId: number): string => {
  const person = personList.find((p) => p.id === personId)
  return person ? person.personUuid : ''
}
